export default "__VITE_ASSET__DM3$elsu__"